import React, { useContext, useEffect } from "react";
import Default from "./Default";
import Graduation from "./Graduation";
import Foods from "./Foods";
import Ecommerce from "./Ecommerce";
import Essay from "./Essay";
import Corporate from "./Corporate";
import Party from "./Party";
import Pet from "./Pet";
import RealState from "./RealState";
import MultiStepFormContext from "~/contexts/MultiSelectForm/MultiSelectFormContext";
import SportsModal from "~/components/confort/Book/Form/Briefing/SportsModal";

type BriefingProps = {
    goToStep?: (step: number) => void;
    prevStep?: () => void;
    nextStep?: () => void;
    currentStep?: number;
};

const Briefing = (props: BriefingProps) => {
    const { values, updateStepStorage, currentStep, handleChange } =
        useContext(MultiStepFormContext);

    updateStepStorage("briefing_step", currentStep);

    const briefings = [
        {
            categoryId: '00',
            component: SportsModal,
        },
        {
            categoryId: 7,
            component: Essay,
        },
        {
            categoryId: 17,
            component: RealState,
        },
        {
            categoryId: 18,
            component: Ecommerce,
        },
        {
            categoryId: 19,
            component: Foods,
        },
        {
            categoryId: 20,
            component: Corporate,
        },
        {
            categoryId: 22,
            component: Party,
        },
        {
            categoryId: 28,
            component: Pet,
        },
        {
            categoryId: 35,
            component: Graduation,
        },
        {
            categoryId: 23,
            component: Default,
        },
        {
            categoryId: 24,
            component: Default,
        },
    ];

    const CurrentBriefing = briefings.find((briefing) => briefing.categoryId === values.category);

    useEffect(() => {
        handleChange("category", values.category);
    }, [values.category]);

    return (
        <>
            <CurrentBriefing.component currentStep={props.currentStep} {...props} />
        </>
    );
};
export default Briefing;
